import React, { useState } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../css/App.css";
import Aboutme from "./Aboutme";
import Experience from "./Experience";
import Contactme from "./Contactme";
import Navbar from "./Navbar";
import TechStack from "./Techstack";
import SocialLinks from "./SocialLinks";
import Portfolio from "./Portfolio";
import { Analytics } from "@vercel/analytics/react"

function App() {
  const [activeSection, setActiveSection] = useState("about");

  const renderSection = () => {
    switch (activeSection) {
      case "about": return <Aboutme />;
      case "experience": return <Experience />;
      case "contact": return <Contactme />;
      case "techstack": return <TechStack />;
      case "sociallinks": return <SocialLinks />;
      case "portfolio": return <Portfolio/>;
      default:
        return null;
    }
  };

  /* data-section drives the accent tokens in index.css — the whole page
     retunes its hue when you move between sections. */
  return (
    <div className="app" data-section={activeSection}>
      <div className="background" aria-hidden="true"></div>
      <div className="container">
        {/* Profile Section with Overlay Navbar */}
        <aside className="profile-section">
          <Navbar activeSection={activeSection} setActiveSection={setActiveSection} />
          <div className="profile-image" role="img" aria-label="Portrait of Marco Conti">
            <div className="profile-nameplate">
              <span className="profile-name">Marco Conti</span>
              <span className="profile-role">Full stack engineer · London</span>
            </div>
          </div>
        </aside>

        {/* Main Content */}
        <Analytics />
        <main className="main-content" key={activeSection}>{renderSection()}</main>
      </div>
    </div>
  );
}

export default App;
